/**
 * Location Service - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as locationMock from '../../mocks/store-resource/location';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  LocationDTO,
  QueryLocationPageRequest,
} from '../../types/store-resource/location';

/**
 * 分页查询库位列表
 */
export async function pageLocation(
  params: QueryLocationPageRequest
): Promise<ApiResponse<PageData<LocationDTO>>> {
  if (config.mock) {
    return locationMock.mockPageLocation(params);
  }

  return httpClient.post(API_ENDPOINTS.LOCATION.PAGE, params);
}

/**
 * 查询库位详情
 */
export async function getLocationByCode(
  locationCode: string
): Promise<ApiResponse<LocationDTO>> {
  if (config.mock) {
    return locationMock.mockGetLocationByCode(locationCode);
  }

  return httpClient.get(`${API_ENDPOINTS.LOCATION.BASE}/${locationCode}`);
}

/**
 * 导出商品库位关系
 */
export async function exportLocation(
  params: { itemCode?: string; locationCode?: string }
): Promise<ApiResponse<string>> {
  return httpClient.post(API_ENDPOINTS.LOCATION.EXPORT, params);
}

/**
 * 导入商品库位关系 CSV 文件（模拟 SFTP 文件传输）
 * 上传 CSV → OSS → 发送 MQ → Processor 消费入库
 */
export async function importLocationFile(
  file: File
): Promise<ApiResponse<string>> {
  const formData = new FormData();
  formData.append('file', file);
  return httpClient.post(API_ENDPOINTS.LOCATION.IMPORT, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
